import { render, staticRenderFns } from "./ConsultaConfiguravelView.vue?vue&type=template&id=3968663f"
import script from "./ConsultaConfiguravelView.vue?vue&type=script&lang=js"
export * from "./ConsultaConfiguravelView.vue?vue&type=script&lang=js"
import style0 from "./ConsultaConfiguravelView.vue?vue&type=style&index=0&id=3968663f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports